import { render, staticRenderFns } from "./Spec.vue?vue&type=template&id=7dfaff0d"
import script from "./Spec.vue?vue&type=script&lang=js"
export * from "./Spec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports